/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Deleteorganization2Inputs */

const zh_organizationsettings_deleteorganization2 = /** @type {(inputs: Organizationsettings_Deleteorganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除组织`)
};

const en_organizationsettings_deleteorganization2 = /** @type {(inputs: Organizationsettings_Deleteorganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Organization`)
};

const es_organizationsettings_deleteorganization2 = /** @type {(inputs: Organizationsettings_Deleteorganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar organización`)
};

/**
* | output |
* | --- |
* | "Delete Organization" |
*
* @param {Organizationsettings_Deleteorganization2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_deleteorganization2 = /** @type {((inputs?: Organizationsettings_Deleteorganization2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Deleteorganization2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_deleteorganization2(inputs)
	if (locale === "en") return en_organizationsettings_deleteorganization2(inputs)
	return es_organizationsettings_deleteorganization2(inputs)
});
export { organizationsettings_deleteorganization2 as "organizationSettings_deleteOrganization" }